<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="schedule-container">
	<div *ngIf="!showExportPage">
		<ol class="vertical-spacing-xl">
			<li class="vertical-spacing-xl">{{ strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_1 }}</li>
			<li class="vertical-spacing-xl">
				{{ strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_2 }}&nbsp;<strong>{{
					strings.EXTERNAL_SCHEDULE_UPLOAD_BUTTON_TEXT
				}}</strong
				>{{ strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_3 }}
			</li>
			<li class="vvertical-spacing-xl">
				{{ strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_4 }}&nbsp;<strong>{{
					strings.EXTERNAL_SCHEDULE_BUTTON_TEXT
				}}</strong
				>{{ strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_5 }}
			</li>
			<br />
			{{
				strings.EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_6
			}}
		</ol>

		<div class="file-uploader-container">
			<span
				><a [href]="strings.EXTERNAL_SCHEDULE_LINK" target="_blank" class="vertical-spacing-xxl"
					>Learn More</a
				></span
			>
			<div class="file-uploader-parent">
				<mat-file-upload
					class="file-uploader"
					[formControl]="fileContent"
					[acceptedFileTypes]="SCHEDULE_FILE_TYPES"
					[outputFormat]="UploadOutputFormat.BinaryString"
					[validationErrors]="validationErrorDef"
					[placeholder]="strings.EXTERNAL_SCHEDULE_FILE_UPLOAD_PLACEHOLDER"
					[buttonText]="strings.EXTERNAL_SCHEDULE_UPLOAD_BUTTON_TEXT"
					[startupMessage]="strings.EXTERNAL_SCHEDULE_FILE_UPLOAD_STARTUP_MESSAGE"
					[successMessage]="strings.EXTERNAL_SCHEDULE_FILE_UPLOAD_SUCCESS_MESSAGE"
					(fileSelectedEvent)="handleFileSelection($event)"
				></mat-file-upload>
				<div class="export-button">
					<button
						mat-stroked-button
						color="primary"
						(click)="exportMilestones()"
						[disabled]="!(this.fileContent.valueChanges | async) || !fileContent.valid"
					>
						{{ strings.EXTERNAL_SCHEDULE_BUTTON_TEXT | uppercase }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="showExportPage">
		<div class="export-control-container">
			<mat-status-indicator
				class="export-indicator"
				[state]="exportIndicatorState"
				[scalePercent]="40"
				[spinnerMode]="'indeterminate'"
				[spinnerValue]="75"
			>
			</mat-status-indicator>
			<span class="export-message">
				{{
					!exportCompleted
						? strings.EXTERNAL_SCHEDULE_EXPORTING_MESSAGE
						: strings.EXTERNAL_SCHEDULE_EXPORTED_MESSAGE(exportCount)
				}}
			</span>
			<div>
				<button
					mat-stroked-button
					color="primary"
					[disabled]="exportIndicatorState === MatStatusIndicatorState.Failure"
					(click)="downloadOrCancel()"
				>
					{{
						(exportCompleted ? strings.EXTERNAL_SCHEDULE_DOWNLOAD_BUTTON_TEXT : strings.UICONTROL_TEXT_CANCEL)
							| uppercase
					}}
				</button>
			</div>
		</div>
		<div class="export-error-list">
			<text-display-container #displayContainer></text-display-container>
		</div>
	</div>

	<button-footer
		(buttonSaveOrClose)="onClose()"
		[saveOrCloseButtonText]="strings.UICONTROL_TEXT_CLOSE | uppercase"
	>
	</button-footer>
</div>
